// src/pages/Cleaning/Swaps/CleaningSwapDetails.jsx

import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../../config";
import {
  FaCheckCircle,
  FaMapMarkerAlt,
  FaClock,
  FaCalendarAlt,
  FaDollarSign,
  FaDoorOpen,
  FaCar,
  FaDog,
  FaBroom,
  FaBath,
  FaToilet,
  FaStar,
  FaListAlt,
  FaBed,
} from "react-icons/fa";



/* ----------------- helpers ----------------- */

function Section({ title, color, children }) {
  return (
    <section style={{ marginTop: "25px" }}>
      <h2 style={{ borderBottom: `2px solid ${color}`, paddingBottom: "5px" }}>
        {title}
      </h2>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "15px",
          marginTop: "10px",
        }}
      >
        {children}
      </div>
    </section>
  );
}

function Info({ icon, label, value, isText = false }) {
  let displayValue = value;

  if (!isText) {
    if (
      value === true ||
      value === 1 ||
      value === "1" ||
      value === "true" ||
      value === "yes" ||
      value === "Yes"
    ) {
      displayValue = "Yes";
    } else if (
      value === false ||
      value === 0 ||
      value === "0" ||
      value === "false" ||
      value === "no" ||
      value === "No"
    ) {
      displayValue = "No";
    }
  }

  if (displayValue === null || displayValue === undefined || displayValue === "") {
    displayValue = "—";
  }

  return (
    <div
      style={{
        background: "#f8f9fa",
        borderRadius: "12px",
        padding: "14px 16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
      }}
    >
      <div style={{ color: "#2e7d32", fontSize: "1.2rem" }}>
        {icon}
      </div>

      <div>
        <div style={{ fontWeight: 700 }}>{label}</div>
        <div style={{ color: "#555" }}>{displayValue}</div>
      </div>
    </div>
  );
}

function TaskRow({ label, active }) {
  return (
    <label style={taskRow}>
      <input type="checkbox" checked={!!active} readOnly />
      <span style={{ textTransform: "capitalize" }}>{label}</span>
    </label>
  );
}

const TASK_DEFINITIONS = [
  { key: "dusting", label: "dusting" },
  { key: "vacuuming", label: "vacuuming" },
  { key: "mopping", label: "mopping" },
  { key: "surfacesWiped", label: "surfaces wiped" },
  { key: "tidying", label: "tidying" },
  { key: "kitchenCleaning", label: "kitchen cleaning" },
  { key: "bathroomCleaning", label: "bathroom cleaning" },
  { key: "bedMaking", label: "bed making" },
  { key: "linenChanging", label: "linen changing" },
  { key: "washing", label: "washing" },
  { key: "ironing", label: "ironing" },
  { key: "pantryTidying", label: "pantry tidying" },
  { key: "loungeVacuum", label: "lounge vacuum" },
  { key: "cobwebRemoval", label: "cobweb removal" },
  { key: "lightSpotCleaning", label: "light spot cleaning" },
  { key: "dishwashing", label: "dishwashing" },
  { key: "organisation", label: "organisation" },
];

/* ----------------- component ----------------- */

function CleaningSwapDetails() {
    const user = JSON.parse(localStorage.getItem("user"));

  const { id } = useParams();
  const navigate = useNavigate();
  const [swap, setSwap] = useState(null);
  const [message, setMessage] = useState("");
  const [errMsg, setErrMsg] = useState("");
    const location = useLocation();
  const fromInbox = location.state?.fromInbox === true;




  useEffect(() => {
    async function load() {
      try {
        setErrMsg("");
        setSwap(null);

        const res = await fetch(
          `${API_BASE_URL}/api/cleaning/swap-listings/${id}`
        );
        const data = await res.json();

        if (!res.ok) {
          setErrMsg(data?.error || "Failed to load swap listing");
          return;
        }

        const listing = data.listing || data.data || data.swap || data;
        setSwap(listing);
      } catch (e) {
        console.error("❌ Failed to load cleaning swap listing:", e);
        setErrMsg("Failed to load swap listing");
      }
    }

    load();
  }, [API_BASE_URL, id]);

  if (errMsg) return <p style={{ padding: 20, color: "red" }}>{errMsg}</p>;
  if (!swap) return <p style={{ padding: 20 }}>Loading swap…</p>;
  
  // --- Posted date (cleaning swaps)
const formattedDate =
  swap.createdAt || swap.created_at
    ? new Date(swap.createdAt || swap.created_at).toLocaleDateString("en-AU")
    : "—";

    const isOwner =
    user && swap && Number(user.id) === Number(swap.userId);

const getGoogleMapsLink = (suburb, postcode, state) => {
  const location = `${suburb || ""} ${postcode || ""} ${state || ""} Australia`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
};

  const services = swap.services || {};

  return (
    <div style={container}>
      <img src="/images/cleaning.jpg" alt="Cleaning" style={hero} />

      <div style={{ padding: "25px" }}>
        <h2 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          🔁 Cleaning Swap – {swap.listingId}
        </h2>

        {/* SWAP LOCATIONS */}
     <Section title="📍 Swap Locations" color="#8e24aa">
<a
  href={getGoogleMapsLink(
    swap.swap_from_suburb,
    swap.swap_from_postcode,
    swap.swap_from_state
  )}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    textDecoration: "none",
    color: "inherit",
  }}
>
  <Info
    icon={
      <span
        style={{
          display: "inline-block",
          transition: "transform 0.2s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <FaMapMarkerAlt />
      </span>
    }
    label="From"
    value={
      swap.swap_from_suburb
        ? `${swap.swap_from_suburb}${swap.swap_from_postcode ? `, ${swap.swap_from_postcode}` : ""}`
        : "N/A"
    }
    isText
  />
</a>

 <a
  href={getGoogleMapsLink(
    swap.swap_to_suburb,
    swap.swap_to_postcode,
    swap.swap_to_state
  )}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    textDecoration: "none",
    color: "inherit",
  }}
>
  <Info
    icon={
      <span
        style={{
          display: "inline-block",
          transition: "transform 0.2s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <FaMapMarkerAlt />
      </span>
    }
    label="To"
    value={
      swap.swap_to_suburb
        ? `${swap.swap_to_suburb}${swap.swap_to_postcode ? `, ${swap.swap_to_postcode}` : ""}${swap.swap_to_state ? ` (${swap.swap_to_state})` : ""}`
        : "N/A"
    }
    isText
  />
</a>
</Section>

             {/* HOME & AREAS */}
        <Section title="🏠 Home & Areas" color="#1e88e5">
          
          <Info icon={<FaBed />} label="Bedrooms Cleaned" value={swap.bedroomsCleaned} isText />
          <Info icon={<FaBath />} label="Bathrooms Cleaned" value={swap.bathroomsCleaned} isText />
          <Info icon={<FaToilet />} label="Toilets Cleaned" value={swap.toiletsCleaned} isText />
        </Section>

        {/* SERVICE SCHEDULE */}
        <Section title="📅 Service Schedule" color="#43a047">
          <Info
            icon={<FaClock />}
            label="Cleaning Time"
            value={
              swap.cleaningTime !== null && swap.cleaningTime !== undefined && swap.cleaningTime !== ""
                ? `${swap.cleaningTime} hr`
                : "—"
            }
            isText
          />
          <Info
            icon={<FaCalendarAlt />}
            label="Frequency"
            value={swap.frequency === "every_3_weeks" ? "Every 3 Weeks" : swap.frequency}
            isText
          />
          <Info
            icon={<FaStar />}
            label="Preferred"
            value={`${swap.serviceDay || "—"} / ${swap.serviceTime || "—"}`}
            isText
          />
        </Section>

        {/* ACCESS */}
        <Section title="🚪 Access Requirements" color="#6d4c41">
          <Info icon={<FaDoorOpen />} label="Access Type" value={swap.accessType} isText />
          <Info icon={<FaDog />} label="Pets at Home" value={swap.petsAtHome} />
          <Info icon={<FaCar />} label="Street Parking" value={swap.streetParking} />
          <Info icon={<FaDoorOpen />} label="Alarm Code Required" value={swap.alarmCodeRequired} />
        </Section>

        {/* TASKS */}
        <Section title="🧼 Routine Cleaning Tasks" color="#8e24aa">
          <div style={{ gridColumn: "1 / -1" }}>
            <div style={tasksGrid}>
              {TASK_DEFINITIONS
                .filter((task) => services[task.key])
                .map((task) => (
                  <p key={task.key} style={{ margin: "4px 0" }}>
                    ✔ {task.label}
                  </p>
                ))}
            </div>
          </div>
        </Section>

        {/* VALUE */}
        <Section title="💰 Swap Value" color="#fb8c00">
          <Info
            icon={<FaDollarSign />}
            label="Average Job Price"
            value={
              swap.avg_job_price !== null && swap.avg_job_price !== undefined
                ? `$${Number(swap.avg_job_price).toFixed(2)}`
                : "Not specified"
            }
            isText
          />
          <Info icon={<FaListAlt />} label="Status" value={swap.swap_status} isText />
        </Section>

        {/* Listing Verification */}
        <div style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <FaCheckCircle color="#2e7d32" />
            <strong>Posted On: {formattedDate}</strong>
          </div>

  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "6px",
      color: "#2e7d32",
    }}
  >
    <FaCheckCircle />
    Seller confirmed this listing is genuine.
  </div>
</div>


        {/* SWAP CTA – like Lawn Mowing */}
       {!isOwner && (
  <>
    <button
      style={{
        ...swapBtn,
        backgroundColor: fromInbox ? "#ccc" : "#2e7d32",
        cursor: fromInbox ? "not-allowed" : "pointer",
        opacity: fromInbox ? 0.7 : 1,
      }}
      disabled={fromInbox}
    onClick={() => {
  if (fromInbox) return;

  if (!user) {
    setMessage("❌ You must be logged in to request a swap.");
    setTimeout(() => navigate("/login"), 1200);
    return;
  }

  navigate(`/cleaning/swaps/${swap.id}/request`);
}}


    >
      🔁 Swap This Cleaning Client
      {message && (
  <p style={{ color: "red", fontWeight: "600", marginTop: "10px" }}>
    {message}
  </p>
)}
    </button>

    {fromInbox && (
      <p style={{ marginTop: 10, color: "#777", fontSize: "14px" }}>
        This swap request is pending your decision. You can accept or decline it from your inbox.
      </p>
    )}
  </>
)}




        <div style={{ marginTop: "30px" }}>
          <Link to="/cleaning/swaps" style={backBtn}>
            ← Back to Cleaning Swaps
          </Link>
        </div>
      </div>
    </div>
  );
}

/* ----------------- styles ----------------- */

const container = {
  maxWidth: "900px",
  margin: "40px auto",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const hero = {
  width: "100%",
  height: "260px",
  objectFit: "cover",
};

const sectionTitle = {
  borderBottom: "2px solid #a020f0",
  paddingBottom: "6px",
  marginBottom: "10px",
};

const swapBtn = {
  marginTop: "20px",
  padding: "14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontWeight: "bold",
  cursor: "pointer",
  width: "100%",
  fontSize: "16px",
};

const backBtn = {
  padding: "10px 16px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
};

const tasksGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "4px 24px",
};

const taskRow = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "0.95rem",
};

export default CleaningSwapDetails;